/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import RangeEntry, { displayStringFromFHIRRange } from "../../datatypeComponents/RangeEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../../datatypeComponents/QuantityEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, displayStringFromFHIRCodeableConcept, simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import ExpressionEntry, { DisplayFromFHIRExpression } from "../../datatypeComponents/ExpressionEntry";
import BooleanEntry, { displayStringFromFHIRBoolean } from "../../datatypeComponents/BooleanEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import UnsignedIntEntry from "../../datatypeComponents/UnsignedIntEntry";
import { Button, Dropdown, Table } from "semantic-ui-react";
import SEVCO, { attributeStatisticsConceptSet, categoricalStatisticsConceptSet, comparativeStatisticsConceptSet, continuousStatisticsConceptSet, dichotomousStatisticsConceptSet, statisticTypeCodeableConceptSet } from "../../dictionaries/SEVCO";
import DecimalEntry from "../../datatypeComponents/DecimalEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../../slices/resourceChangeReport/resourceChangeReportSlice";
import updateChangeReport from "../../slices/resourceChangeReport/updateChangeReport";
import { resourceUpdated, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import ExpandToAddOrEdit from "../../components/ExpandToAddOrEdit";
import DatatypeSelector from "../../datatypeComponents/DatatypeSelector";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import NarrativeEntry from "../../datatypeComponents/NarrativeEntry";
import generateNarrativeForEvidenceResource from "../generateNarrativeFunctions/generateNarrativeForEvidenceResource";
import convertEvidenceVariableHandlingToCodeableConcept from "../resourceDisplayCommonFunctions/convertEvidenceVariableHandlingToCodeableConcept";
import { evidenceVariableDotHandlingValueSet } from "../EvidenceVariableResourceDisplay";

const ModelCharacteristicDisplay = ({ modelCharactersticInstance }) => {
    let modelVariable = <></>;
    let modelVariableFound = false;
    if (modelCharactersticInstance.variable) {
        modelVariable = <>Adjusted for:<ul style={{ marginTop: "0px" }}>{modelCharactersticInstance.variable.map((variable, variableIndex) => {
            if (variable.variableDefinition) {
                modelVariableFound = true;
                let includeIfFound = false;
                let includeIfString;
                let variableHandling = "";
                if (variable.handling) {
                    if (typeof variable.handling === "string") {
                        variableHandling = variable.handling;
                    } else {
                        variableHandling = simpleDisplayStringFromFHIRCodeableConcept(variable.handling);
                    }
                }
                if (variable.extension?.length > 0) {
                    for (const extension of variable.extension) {
                        if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                            extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                            extension.url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                            includeIfFound = true;
                            includeIfString = " {{ include if ";
                            for (const ext of extension.extension) {
                                if (ext.url === "attribute") {
                                    includeIfString += displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept) || "";
                                    includeIfString += " IS "
                                } else if (ext.url === "value") {
                                    if (typeof ext.valueBoolean === 'boolean') {
                                        includeIfString += displayStringFromFHIRBoolean(ext.valueBoolean);
                                    } else if (ext.valueCodeableConcept) {
                                        includeIfString += displayStringFromFHIRCodeableConcept(ext.valueCodeableConcept);
                                    } else if (ext.valueQuantity) {
                                        includeIfString += displayStringFromFHIRQuantity(ext.valueQuantity);
                                    } else if (ext.valueRange) {
                                        includeIfString += displayStringFromFHIRRange(ext.valueRange);
                                    } else if (ext.valueExpression) {
                                        includeIfString += ext.valueExpression.name + " " + ext.valueExpression.description + " " + ext.valueExpression.expression;
                                    }
                                }
                            }
                            includeIfString += " }}";
                        }
                    }
                }
                return <li key={variableIndex}>{variable.variableDefinition.display && <>{variable.variableDefinition.display}</>} {variableHandling && <>({variableHandling})</>} {includeIfFound && <>{includeIfString}</>}</li>
            } else {
                return <></>
            }
        })}</ul></>
    }
    let modelAttributeEstimate = <></>;
    let modelAttributeEstimateFound = false;
    if (modelCharactersticInstance.attribute || modelCharactersticInstance.attributeEstimate) {
        modelAttributeEstimate = <><p>Placeholder -- this model characteristic contains one or more attribute estimates</p></>;
        modelAttributeEstimateFound = true;
    }
    let includeIfFound = false;
    let includeIfExtension;
    if (modelCharactersticInstance.extension?.length > 0) {
        for (const extension of modelCharactersticInstance.extension) {
            if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                extension.url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                includeIfFound = true;
                includeIfExtension = {};
                for (const ext of extension.extension) {
                    if (ext.url === "attribute") {
                        includeIfExtension["attribute"] = ext.valueCodeableConcept || "";
                    } else if (ext.url === "value") {
                        if (typeof ext.valueBoolean === 'boolean') {
                            includeIfExtension["valueBoolean"] = ext.valueBoolean;
                        } else if (ext.valueCodeableConcept) {
                            includeIfExtension["valueCodeableConcept"] = ext.valueCodeableConcept;
                        } else if (ext.valueQuantity) {
                            includeIfExtension["valueQuantity"] = ext.valueQuantity;
                        } else if (ext.valueRange) {
                            includeIfExtension["valueRange"] = ext.valueRange;
                        } else if (ext.valueExpression) {
                            includeIfExtension["valueExpression"] = ext.valueExpression;
                        }
                    }
                }
            }
        }
    }
    return <>
        {includeIfFound && <div>
            <b>Include if: </b>
            <div style={{ marginLeft: "24px" }}>
                <div>
                    <b>Attribute: </b>
                    <DisplayFromFHIRCodeableConcept codeableConcept={includeIfExtension.attribute} />
                </div>
                <div>
                    <b>Value: </b>
                    {typeof includeIfExtension.valueBoolean === 'boolean' &&
                        displayStringFromFHIRBoolean(includeIfExtension.valueBoolean)}
                    {includeIfExtension.valueCodeableConcept &&
                        <DisplayFromFHIRCodeableConcept codeableConcept={includeIfExtension.valueCodeableConcept} />}
                    {includeIfExtension.valueQuantity &&
                        displayStringFromFHIRQuantity(includeIfExtension.valueQuantity)}
                    {includeIfExtension.valueRange &&
                        displayStringFromFHIRRange(includeIfExtension.valueRange)}
                    {includeIfExtension.valueExpression &&
                        <DisplayFromFHIRExpression expression={includeIfExtension.valueExpression} />}
                </div>
            </div>
        </div>}
        {modelCharactersticInstance.conditionCodeableConcept && <span>
            <b>If this condition is met: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.conditionCodeableConcept} />
        </span>}
        {modelCharactersticInstance.conditionExpression && <span>
            <b>If this condition is met: </b>
            <DisplayFromFHIRExpression expression={modelCharactersticInstance.conditionExpression} />
        </span>}
        {modelCharactersticInstance.code && <span>
            <br />
            <b>Code: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.code} />
        </span>}
        {modelCharactersticInstance.value && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRQuantity(modelCharactersticInstance.value)}
        </span>}
        {modelCharactersticInstance.valueQuantity && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRQuantity(modelCharactersticInstance.valueQuantity)}
        </span>}
        {modelCharactersticInstance.valueRange && <span>
            <br />
            <b>Value: </b>
            {displayStringFromFHIRRange(modelCharactersticInstance.valueRange)}
        </span>}
        {modelCharactersticInstance.valueCodeableConcept && <span>
            <br />
            <b>Value: </b>
            <DisplayFromFHIRCodeableConcept codeableConcept={modelCharactersticInstance.valueCodeableConcept} />
        </span>}
        {modelCharactersticInstance.intended && <p><b>Intended: </b>True</p>}
        {modelCharactersticInstance.applied && <p><b>Applied: </b>True</p>}
        {modelVariableFound && modelVariable}
        {modelAttributeEstimateFound && modelAttributeEstimate}
        {(Array.isArray(modelCharactersticInstance.modelCharacteristic) &&
            modelCharactersticInstance.modelCharacteristic.length > 0) &&
            modelCharactersticInstance.modelCharacteristic.map((item, itemIndex) => {
                return <div key={itemIndex}>
                    <p><b>Model Characteristic {itemIndex + 1} of {modelCharactersticInstance.modelCharacteristic.length}</b></p>
                    <ModelCharacteristicDisplay modelCharactersticInstance={item} />
                </div>
            })}
    </>
};

const EvidenceStatisticSampleSizeEntry = ({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle }) => {

    const [evidenceStatisticSampleSizeState, setEvidenceStatisticSampleSizeState] = useState({});

    useEffect(() => {
        let startingSampleSize = {
            description: "", note: [], numberOfStudies: "", numberOfParticipants: "", numberAnalyzed: "", knownDataCount: ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingSampleSize.extension = startingValue.extension; }
            if (startingValue.description) { startingSampleSize.description = startingValue.description; }
            if (startingValue.note) { startingSampleSize.note = startingValue.note; }
            if (startingValue.numberOfStudies || startingValue.numberOfStudies === 0) { startingSampleSize.numberOfStudies = startingValue.numberOfStudies; }
            if (startingValue.numberOfParticipants || startingValue.numberOfParticipants === 0) { startingSampleSize.numberOfParticipants = startingValue.numberOfParticipants; }
            if (startingValue.numberAnalyzed || startingValue.numberAnalyzed === 0) { startingSampleSize.numberAnalyzed = startingValue.numberAnalyzed; }
            if (startingValue.knownDataCount || startingValue.knownDataCount === 0) { startingSampleSize.knownDataCount = startingValue.knownDataCount; }
        }
        setEvidenceStatisticSampleSizeState(JSON.parse(JSON.stringify(startingSampleSize)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceStatisticSampleSizeState).length > 0) {
            let newStatisticSampleSize = {};
            if (evidenceStatisticSampleSizeState.extension) { newStatisticSampleSize.extension = evidenceStatisticSampleSizeState.extension; }
            if (evidenceStatisticSampleSizeState.description) { newStatisticSampleSize.description = evidenceStatisticSampleSizeState.description; }
            if (Array.isArray(evidenceStatisticSampleSizeState.note) && evidenceStatisticSampleSizeState.note.length > 0) {
                newStatisticSampleSize.note = evidenceStatisticSampleSizeState.note;
            }
            if (evidenceStatisticSampleSizeState.numberOfStudies || evidenceStatisticSampleSizeState.numberOfStudies === 0) {
                newStatisticSampleSize.numberOfStudies = evidenceStatisticSampleSizeState.numberOfStudies;
            }
            if (evidenceStatisticSampleSizeState.numberOfParticipants || evidenceStatisticSampleSizeState.numberOfParticipants === 0) {
                newStatisticSampleSize.numberOfParticipants = evidenceStatisticSampleSizeState.numberOfParticipants;
            }
            if (evidenceStatisticSampleSizeState.numberAnalyzed || evidenceStatisticSampleSizeState.numberAnalyzed === 0) {
                newStatisticSampleSize.numberAnalyzed = evidenceStatisticSampleSizeState.numberAnalyzed;
            }
            if (evidenceStatisticSampleSizeState.knownDataCount || evidenceStatisticSampleSizeState.knownDataCount === 0) {
                newStatisticSampleSize.knownDataCount = evidenceStatisticSampleSizeState.knownDataCount;
            }
            if (Object.keys(newStatisticSampleSize).length === 0) {
                newStatisticSampleSize = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newStatisticSampleSize }; });
        }
    }), [evidenceStatisticSampleSizeState]);

    if (Object.keys(evidenceStatisticSampleSizeState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startingValue={evidenceStatisticSampleSizeState.description} setResourceState={setEvidenceStatisticSampleSizeState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticSampleSizeState.note} setResourceState={setEvidenceStatisticSampleSizeState} />
                <br /><br />
                <span><b>Number of Studies:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberOfStudies' fieldLabel='Number of Studies'
                        startingValue={evidenceStatisticSampleSizeState.numberOfStudies}
                        setResourceState={setEvidenceStatisticSampleSizeState} />
                </span>
                <br /><br />
                <span><b>Number of Participants:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberOfParticipants' fieldLabel='Number of Participants'
                        startingValue={evidenceStatisticSampleSizeState.numberOfParticipants}
                        setResourceState={setEvidenceStatisticSampleSizeState} />
                </span>
                <br /><br />
                <span><b>Number Analyzed:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAnalyzed' fieldLabel='Number Analyzed'
                        startingValue={evidenceStatisticSampleSizeState.numberAnalyzed}
                        setResourceState={setEvidenceStatisticSampleSizeState} />
                </span>
                <br /><br />
                <span><b>Known Data Count:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='knownDataCount' fieldLabel='Known Data Count'
                        startingValue={evidenceStatisticSampleSizeState.knownDataCount}
                        setResourceState={setEvidenceStatisticSampleSizeState} />
                </span>
            </div>
        </>
    }
};

const EvidenceStatisticAttributeEstimateEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceStatisticAttributeEstimateState, setEvidenceStatisticAttributeEstimateState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingAttributeEstimate = {
            description: "", note: [], type: "", quantity: "", level: "", range: "", attributeEstimate: ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingAttributeEstimate.extension = startingValue.extension; }
            if (startingValue.description) { startingAttributeEstimate.description = startingValue.description; }
            if (startingValue.note) { startingAttributeEstimate.note = startingValue.note; }
            if (startingValue.type) { startingAttributeEstimate.type = startingValue.type; }
            if (startingValue.quantity) { startingAttributeEstimate.quantity = startingValue.quantity; }
            if (startingValue.level) { startingAttributeEstimate.level = startingValue.level; }
            if (startingValue.range) { startingAttributeEstimate.range = startingValue.range; }
            if (startingValue.attributeEstimate) { startingAttributeEstimate.attributeEstimate = startingValue.attributeEstimate; }
        }
        setEvidenceStatisticAttributeEstimateState(JSON.parse(JSON.stringify(startingAttributeEstimate)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceStatisticAttributeEstimateState).length > 0) {
            let newAttributeEstimate = {};
            if (evidenceStatisticAttributeEstimateState.extension) { newAttributeEstimate.extension = evidenceStatisticAttributeEstimateState.extension; }
            if (evidenceStatisticAttributeEstimateState.description) { newAttributeEstimate.description = evidenceStatisticAttributeEstimateState.description; }
            if (Array.isArray(evidenceStatisticAttributeEstimateState.note) && evidenceStatisticAttributeEstimateState.note.length > 0) {
                newAttributeEstimate.note = evidenceStatisticAttributeEstimateState.note;
            }
            if (evidenceStatisticAttributeEstimateState.type && Object.keys(evidenceStatisticAttributeEstimateState.type).length > 0) {
                newAttributeEstimate.type = evidenceStatisticAttributeEstimateState.type;
            }
            if (evidenceStatisticAttributeEstimateState.quantity && Object.keys(evidenceStatisticAttributeEstimateState.quantity).length > 0) {
                newAttributeEstimate.quantity = evidenceStatisticAttributeEstimateState.quantity;
            }
            if (evidenceStatisticAttributeEstimateState.level || evidenceStatisticAttributeEstimateState.level === 0) {
                newAttributeEstimate.level = evidenceStatisticAttributeEstimateState.level;
            }
            if (evidenceStatisticAttributeEstimateState.range && Object.keys(evidenceStatisticAttributeEstimateState.range).length > 0) {
                newAttributeEstimate.range = evidenceStatisticAttributeEstimateState.range;
            }
            if (Array.isArray(evidenceStatisticAttributeEstimateState.attributeEstimate) && evidenceStatisticAttributeEstimateState.attributeEstimate.length > 0) {
                newAttributeEstimate.attributeEstimate = evidenceStatisticAttributeEstimateState.attributeEstimate;
            }
            if (Object.keys(newAttributeEstimate).length === 0) {
                newAttributeEstimate = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newAttributeEstimate }; });
        }
    }), [evidenceStatisticAttributeEstimateState]);

    let calculatedPercentageAttribute = false;
    let attribute = "";
    let attributeValue = "";
    if (startingValue) {
        if (startingValue.level) {
            attribute = 100 * startingValue.level + "% ";
        }
        if (startingValue.type) {
            if (startingValue.type.coding?.length > 0) {
                if (startingValue.type.coding[0].display) {
                    attribute += startingValue.type.coding[0].display;
                } else if (startingValue.type.coding[0].code) {
                    attribute += startingValue.type.coding[0].code;
                }
            }
            if (startingValue.type.text) {
                if (startingValue.type.text.toLowerCase() === "percentage") {
                    calculatedPercentageAttribute = true;
                }
                attribute += " " + startingValue.type.text;
            }
        }
        if (startingValue.quantity) {
            let comparator = "";
            if (startingValue.quantity.comparator) {
                comparator = startingValue.quantity.comparator + " ";
            }
            let unit = "";
            if (startingValue.quantity.unit) {
                unit = " " + startingValue.quantity.unit;
            }
            let attributeEstimateValue = "";
            if (startingValue.quantity.value !== undefined) {
                attributeEstimateValue = startingValue.quantity.value
            }
            attributeValue = comparator + startingValue.quantity.value + unit;
            if (calculatedPercentageAttribute && startingValue.quantity.value && (comparator === "" || comparator === " ") && startingValue.quantity.unit === "%") {
                try {
                    //The plus symbol belongs here, +parseFloat(4).toFixed(2) === 4 as an int vs parseFloat(4).toFixed(2) === "4.00" as a string
                    attributeEstimateValue = +parseFloat(startingValue.quantity.value).toFixed(2);
                    if (attributeEstimateValue.toString() !== "NaN") {
                        attributeValue = attributeEstimateValue + unit;
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }
        if (attributeValue === "" && startingValue.range) {
            let lowValue = "No Lower Bound";
            let highValue = "No Upper Bound";
            if (startingValue.range.low?.value !== undefined) {
                lowValue = startingValue.range.low.value;
                if (startingValue.range.low.unit) {
                    lowValue += " " + startingValue.range.low.unit;
                }
            }
            if (startingValue.range.high?.value !== undefined) {
                highValue = startingValue.range.high.value;
                if (startingValue.range.high.unit) {
                    highValue += " " + startingValue.range.high.unit;
                }
            }
            attributeValue = lowValue + " to " + highValue;
        }
    }

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                <Table style={{ margin: "4px" }}>
                    <Table.Header><Table.Row>
                        <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Value</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Notes</Table.HeaderCell>
                    </Table.Row></Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>{attribute}</Table.Cell>
                            <Table.Cell>{attributeValue}</Table.Cell>
                            <Table.Cell>
                                {startingValue.description && <>
                                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                                </>}
                                {startingValue.note && <>
                                    {startingValue.note.map((note, noteIndex) => {
                                        return <span key={noteIndex}>
                                            <b>Note:</b> {note.text}<br />
                                        </span>
                                    })}
                                </>}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(evidenceStatisticAttributeEstimateState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description' startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.description} setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.note} setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <CodeableConceptEntry elementName='type' fieldLabel='Attribute Estimate Type'
                    startingValue={evidenceStatisticAttributeEstimateState.type}
                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={attributeStatisticsConceptSet}
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticAttributeEstimateState.quantity} startCollapsed
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <br /><br />
                <span><b>Level:</b>
                    &nbsp;&nbsp;
                    <DecimalEntry elementName='level' fieldLabel='Level'
                        startingValue={evidenceStatisticAttributeEstimateState.level}
                        setResourceState={setEvidenceStatisticAttributeEstimateState} />
                </span>
                <RangeEntry elementName='range' fieldLabel='Range'
                    startingValue={evidenceStatisticAttributeEstimateState.range} startCollapsed
                    setResourceState={setEvidenceStatisticAttributeEstimateState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticAttributeEstimateState.attributeEstimate} setResourceState={setEvidenceStatisticAttributeEstimateState} />
            </div>
        </>
    }
};

const ExtensionStatisticModelIncludeIfValueAllowedDatatypes = ['boolean', 'CodeableConcept', 'Quantity', 'Range', 'Expression'];
const ExtensionStatisticModelIncludeIfEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {

    //There can/should only be one of these elements: valueBoolean, valueCodeableConcept, valueQuantity, valueRange, or valueExpression

    const [extensionStatisticModelIncludeIfState, setExtensionStatisticModelIncludeIfState] = useState({});
    const [includeIfDotValueDatatypeState, setIncludeIfDotValueDatatypeState] = useState('none');

    useEffect(() => {
        let startingExtensionStatisticModelIncludeIf = {
            otherExtensions: [],
            attribute: null,
            valueBoolean: null,
            valueCodeableConcept: null,
            valueQuantity: null,
            valueRange: null,
            valueExpression: null
        };

        let startingIncludeIfDotValueDatatype = 'none';

        if (Array.isArray(startingValue)) {
            for (const extension of startingValue) {
                if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                    extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                    extension.url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                    for (const ext of extension.extension) {
                        if (ext.url === "attribute") {
                            startingExtensionStatisticModelIncludeIf.attribute = ext.valueCodeableConcept;
                        } else if (ext.url === "value") {
                            if (typeof ext.valueBoolean === 'boolean') {
                                startingExtensionStatisticModelIncludeIf.valueBoolean = ext.valueBoolean;
                                startingIncludeIfDotValueDatatype = "boolean";
                            } else if (ext.valueCodeableConcept) {
                                startingExtensionStatisticModelIncludeIf.valueCodeableConcept = ext.valueCodeableConcept;
                                startingIncludeIfDotValueDatatype = "CodeableConcept";
                            } else if (ext.valueQuantity) {
                                startingExtensionStatisticModelIncludeIf.valueQuantity = ext.valueQuantity;
                                startingIncludeIfDotValueDatatype = "Quantity";
                            } else if (ext.valueRange) {
                                startingExtensionStatisticModelIncludeIf.valueRange = ext.valueRange;
                                startingIncludeIfDotValueDatatype = "Range";
                            } else if (ext.valueExpression) {
                                startingExtensionStatisticModelIncludeIf.valueExpression = ext.valueExpression;
                                startingIncludeIfDotValueDatatype = "Expression";
                            }
                        }
                    }
                } else {
                    startingExtensionStatisticModelIncludeIf.otherExtensions.push(extension);
                }
            }
        }
        setExtensionStatisticModelIncludeIfState(JSON.parse(JSON.stringify(startingExtensionStatisticModelIncludeIf)));
        setIncludeIfDotValueDatatypeState(startingIncludeIfDotValueDatatype);
    }, []);

    useEffect((() => {
        if (includeIfDotValueDatatypeState === 'boolean') {
            setExtensionStatisticModelIncludeIfState(prevState => { return { ...prevState, 'valueCodeableConcept': null, 'valueQuantity': null, 'valueRange': null, 'valueExpression': null } })
        }
        if (includeIfDotValueDatatypeState === 'CodeableConcept') {
            setExtensionStatisticModelIncludeIfState(prevState => { return { ...prevState, 'valueBoolean': null, 'valueQuantity': null, 'valueRange': null, 'valueExpression': null } })
        }
        if (includeIfDotValueDatatypeState === 'Quantity') {
            setExtensionStatisticModelIncludeIfState(prevState => { return { ...prevState, 'valueBoolean': null, 'valueCodeableConcept': null, 'valueRange': null, 'valueExpression': null } })
        }
        if (includeIfDotValueDatatypeState === 'Range') {
            setExtensionStatisticModelIncludeIfState(prevState => { return { ...prevState, 'valueBoolean': null, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueExpression': null } })
        }
        if (includeIfDotValueDatatypeState === 'Expression') {
            setExtensionStatisticModelIncludeIfState(prevState => { return { ...prevState, 'valueBoolean': null, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null } })
        }
    }), [includeIfDotValueDatatypeState]);

    useEffect((() => {
        if (Object.keys(extensionStatisticModelIncludeIfState).length > 0) {
            let newExtension = JSON.parse(JSON.stringify(extensionStatisticModelIncludeIfState.otherExtensions)) || [];
            let extensionIndex;
            for (let index in newExtension) {
                if (newExtension[index].url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                    newExtension[index].url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model-include-if" ||
                    newExtension[index].url === "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if") {
                    extensionIndex = index;
                    break;
                }
            }
            let newIncludeIf = {
                "extension": [
                    {
                        "url": "attribute",
                        "valueCodeableConcept": extensionStatisticModelIncludeIfState.attribute
                    },
                    {
                        "url": "value",
                        "valueBoolean": extensionStatisticModelIncludeIfState.valueBoolean,
                        "valueCodeableConcept": extensionStatisticModelIncludeIfState.valueCodeableConcept,
                        'valueQuantity': extensionStatisticModelIncludeIfState.valueQuantity,
                        'valueRange': extensionStatisticModelIncludeIfState.valueRange,
                        'valueExpression': extensionStatisticModelIncludeIfState.valueExpression
                    }
                ],
                "url": "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if"
            };
            if (extensionStatisticModelIncludeIfState.valueBoolean === null) {
                delete newIncludeIf.extension[1].valueBoolean;
            }
            if (extensionStatisticModelIncludeIfState.valueCodeableConcept === null) {
                delete newIncludeIf.extension[1].valueCodeableConcept;
            }
            if (extensionStatisticModelIncludeIfState.valueQuantity === null) {
                delete newIncludeIf.extension[1].valueQuantity;
            }
            if (extensionStatisticModelIncludeIfState.valueRange === null) {
                delete newIncludeIf.extension[1].valueRange;
            }
            if (extensionStatisticModelIncludeIfState.valueExpression === null) {
                delete newIncludeIf.extension[1].valueExpression;
            }
            if (extensionIndex !== undefined) {
                if (extensionStatisticModelIncludeIfState.attribute ||
                    extensionStatisticModelIncludeIfState.valueCodeableConcept ||
                    extensionStatisticModelIncludeIfState.valueQuantity ||
                    extensionStatisticModelIncludeIfState.valueRange ||
                    extensionStatisticModelIncludeIfState.valueExpression) {
                    newExtension[extensionIndex] = newIncludeIf;
                } else {
                    delete newExtension[extensionIndex];
                }
            } else {
                if (extensionStatisticModelIncludeIfState.attribute ||
                    extensionStatisticModelIncludeIfState.valueCodeableConcept ||
                    extensionStatisticModelIncludeIfState.valueQuantity ||
                    extensionStatisticModelIncludeIfState.valueRange ||
                    extensionStatisticModelIncludeIfState.valueExpression) {
                    newExtension.push(newIncludeIf);
                }
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newExtension }; });
        }
    }), [extensionStatisticModelIncludeIfState]);

    if (Object.keys(extensionStatisticModelIncludeIfState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='attribute' fieldLabel='Type of Condition'
                    startingValue={extensionStatisticModelIncludeIfState.attribute}
                    setResourceState={setExtensionStatisticModelIncludeIfState} />
                <DatatypeSelector elementXName='value[x]'
                    allowedDatatypes={ExtensionStatisticModelIncludeIfValueAllowedDatatypes}
                    datatypeState={includeIfDotValueDatatypeState}
                    setDatatypeState={setIncludeIfDotValueDatatypeState} />
                {includeIfDotValueDatatypeState === 'boolean' &&
                    <BooleanEntry elementName='valueBoolean' fieldLabel='Value as Boolean'
                        startingValue={extensionStatisticModelIncludeIfState.valueBoolean}
                        setResourceState={setExtensionStatisticModelIncludeIfState} />}
                {includeIfDotValueDatatypeState === 'CodeableConcept' &&
                    <CodeableConceptEntry elementName='valueCodeableConcept' fieldLabel='Value as CodeableConcept'
                        startingValue={extensionStatisticModelIncludeIfState.valueCodeableConcept}
                        setResourceState={setExtensionStatisticModelIncludeIfState} />}
                {includeIfDotValueDatatypeState === 'Quantity' &&
                    <QuantityEntry elementName='valueQuantity' fieldLabel='Value as Quantity'
                        startingValue={extensionStatisticModelIncludeIfState.valueQuantity}
                        setResourceState={setExtensionStatisticModelIncludeIfState} />}
                {includeIfDotValueDatatypeState === 'Range' &&
                    <RangeEntry elementName='valueRange' fieldLabel='Value as Range'
                        startingValue={extensionStatisticModelIncludeIfState.valueRange}
                        setResourceState={setExtensionStatisticModelIncludeIfState} />}
                {includeIfDotValueDatatypeState === 'Expression' &&
                    <ExpressionEntry elementName='valueExpression' fieldLabel='Value as Expression'
                        startingValue={extensionStatisticModelIncludeIfState.valueExpression}
                        setResourceState={setExtensionStatisticModelIncludeIfState} />}
            </div>
        </>
    }
};

const EvidenceStatisticModelCharacteristicDotValueAllowedDatatypes = ['CodeableConcept', 'Quantity', 'Range'];
const EvidenceStatisticModelCharacteristicEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed, isStatisticModelProfile, isEndpointAnalysisPlanProfile, isParticipantFlowEvidenceProfile,
    isNetEffectContributionProfile, isNetEffectEstimateProfile }) => {

    const [evidenceStatisticModelCharacteristicState, setEvidenceStatisticModelCharacteristicState] = useState({});
    const [evidenceStatisticModelCharacteristicDotValueDatatypeState, setEvidenceStatisticModelCharacteristicDotValueDatatypeState] = useState('none');
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingModelCharacteristic = {
            extension: [],
            conditionCodeableConcept: "", conditionExpression: "", code: "",
            valueQuantity: "", valueRange: "", valueCodeableConcept: "",
            intended: "", applied: "",
            variable: [], attribute: [], attributeEstimate: [], modelCharacteristic: ""
        }
        let startingEvidenceModelCharacteristicDotValueDatatype = 'none';
        if (startingValue) {
            if (startingValue.extension) { startingModelCharacteristic.extension = startingValue.extension; }
            if (startingValue.conditionCodeableConcept) {
                if (!startingModelCharacteristic.extension) {
                    startingModelCharacteristic.extension = [];
                }
                let includeIf = {
                    "extension": [
                        {
                            "url": "attribute",
                            "valueCodeableConcept": startingValue.conditionCodeableConcept
                        },
                        {
                            "url": "value",
                            "valueBoolean": true
                        }
                    ],
                    "url": "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if"
                };
                startingModelCharacteristic.extension.push(includeIf);
            }
            if (startingValue.conditionExpression) {
                if (!startingModelCharacteristic.extension) {
                    startingModelCharacteristic.extension = [];
                }
                let includeIf = {
                    "extension": [
                        {
                            "url": "attribute",
                            "valueCodeableConcept": { "text": "Defined by Expression" }
                        },
                        {
                            "url": "value",
                            "valueExpression": startingValue.conditionExpression
                        }
                    ],
                    "url": "http://hl7.org/fhir/StructureDefinition/statistic-model-include-if"
                };
                startingModelCharacteristic.extension.push(includeIf);
            }
            if (startingValue.code) { startingModelCharacteristic.code = startingValue.code; }
            if (startingValue.valueCodeableConcept) {
                startingModelCharacteristic.valueCodeableConcept = startingValue.valueCodeableConcept;
                startingEvidenceModelCharacteristicDotValueDatatype = "CodeableConcept";
            }
            if (startingValue.valueQuantity) {
                startingModelCharacteristic.valueQuantity = startingValue.valueQuantity;
                startingEvidenceModelCharacteristicDotValueDatatype = "Quantity";
            }
            if (startingValue.valueRange) {
                startingModelCharacteristic.valueRange = startingValue.valueRange;
                startingEvidenceModelCharacteristicDotValueDatatype = "Range";
            }
            if (typeof startingValue.intended === "boolean") {
                startingModelCharacteristic.intended = startingValue.intended;
            }
            if (typeof startingValue.applied === "boolean") {
                startingModelCharacteristic.applied = startingValue.applied;
            }
            if (startingValue.variable) { startingModelCharacteristic.variable = startingValue.variable; }
            if (startingValue.attribute) { startingModelCharacteristic.attribute = startingValue.attribute; }
            if (startingValue.attributeEstimate) { startingModelCharacteristic.attributeEstimate = startingValue.attributeEstimate; }
            if (startingValue.modelCharacteristic) { startingModelCharacteristic.modelCharacteristic = startingValue.modelCharacteristic; }
        }
        setEvidenceStatisticModelCharacteristicState(JSON.parse(JSON.stringify(startingModelCharacteristic)));
        setEvidenceStatisticModelCharacteristicDotValueDatatypeState(startingEvidenceModelCharacteristicDotValueDatatype);
    }, []);

    useEffect((() => {
        if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'CodeableConcept') {
            setEvidenceStatisticModelCharacteristicState(prevState => { return { ...prevState, 'valueQuantity': null, 'valueRange': null } })
        }
        if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Quantity') {
            setEvidenceStatisticModelCharacteristicState(prevState => { return { ...prevState, 'valueCodeableConcept': null, 'valueRange': null } })
        }
        if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Range') {
            setEvidenceStatisticModelCharacteristicState(prevState => { return { ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null } })
        }
    }), [evidenceStatisticModelCharacteristicDotValueDatatypeState]);

    useEffect((() => {
        if (Object.keys(evidenceStatisticModelCharacteristicState).length > 0) {
            let newModelCharacteristic = {};
            if (evidenceStatisticModelCharacteristicState.extension?.length > 0) { newModelCharacteristic.extension = evidenceStatisticModelCharacteristicState.extension; }
            if (evidenceStatisticModelCharacteristicState.code && Object.keys(evidenceStatisticModelCharacteristicState.code).length > 0) {
                newModelCharacteristic.code = evidenceStatisticModelCharacteristicState.code;
            }
            if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'CodeableConcept' &&
                evidenceStatisticModelCharacteristicState.valueCodeableConcept &&
                Object.keys(evidenceStatisticModelCharacteristicState.valueCodeableConcept).length > 0) {
                newModelCharacteristic.valueCodeableConcept = evidenceStatisticModelCharacteristicState.valueCodeableConcept;
            }
            if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Quantity' &&
                evidenceStatisticModelCharacteristicState.valueQuantity &&
                Object.keys(evidenceStatisticModelCharacteristicState.valueQuantity).length > 0) {
                newModelCharacteristic.valueQuantity = evidenceStatisticModelCharacteristicState.valueQuantity;
            }
            if (evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Range' &&
                evidenceStatisticModelCharacteristicState.valueRange &&
                Object.keys(evidenceStatisticModelCharacteristicState.valueRange).length > 0) {
                newModelCharacteristic.valueRange = evidenceStatisticModelCharacteristicState.valueRange;
            }
            if (typeof evidenceStatisticModelCharacteristicState.intended === "boolean") {
                newModelCharacteristic.intended = evidenceStatisticModelCharacteristicState.intended;
            }
            if (typeof evidenceStatisticModelCharacteristicState.applied === "boolean") {
                newModelCharacteristic.applied = evidenceStatisticModelCharacteristicState.applied;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicState.variable) && evidenceStatisticModelCharacteristicState.variable.length > 0) {
                newModelCharacteristic.variable = evidenceStatisticModelCharacteristicState.variable;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicState.attribute) && evidenceStatisticModelCharacteristicState.attribute.length > 0) {
                newModelCharacteristic.attribute = evidenceStatisticModelCharacteristicState.attribute;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicState.attributeEstimate) && evidenceStatisticModelCharacteristicState.attributeEstimate.length > 0) {
                newModelCharacteristic.attributeEstimate = evidenceStatisticModelCharacteristicState.attributeEstimate;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicState.modelCharacteristic) && evidenceStatisticModelCharacteristicState.modelCharacteristic.length > 0) {
                newModelCharacteristic.modelCharacteristic = evidenceStatisticModelCharacteristicState.modelCharacteristic;
            }
            if (Object.keys(newModelCharacteristic).length === 0) {
                newModelCharacteristic = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newModelCharacteristic }; });
        }
    }), [evidenceStatisticModelCharacteristicState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                <div style={{ marginLeft: "24px" }}>
                    <ModelCharacteristicDisplay modelCharactersticInstance={startingValue} />
                </div>
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(evidenceStatisticModelCharacteristicState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='code' fieldLabel='Model Characteristic Specification'
                    startingValue={evidenceStatisticModelCharacteristicState.code} startCollapsed
                    setResourceState={setEvidenceStatisticModelCharacteristicState} />
                <DatatypeSelector elementXName='value[x]'
                    allowedDatatypes={EvidenceStatisticModelCharacteristicDotValueAllowedDatatypes}
                    datatypeState={evidenceStatisticModelCharacteristicDotValueDatatypeState}
                    setDatatypeState={setEvidenceStatisticModelCharacteristicDotValueDatatypeState} />
                {evidenceStatisticModelCharacteristicDotValueDatatypeState === 'CodeableConcept' &&
                    <CodeableConceptEntry elementName='valueCodeableConcept'
                        fieldLabel='Value as CodeableConcept' startCollapsed
                        startingValue={evidenceStatisticModelCharacteristicState.valueCodeableConcept}
                        setResourceState={setEvidenceStatisticModelCharacteristicState} />}
                {evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Quantity' &&
                    <QuantityEntry dataEntryStyle='SimpleQuantity' elementName='valueQuantity'
                        fieldLabel='Value as Quantity' startCollapsed
                        startingValue={evidenceStatisticModelCharacteristicState.valueQuantity}
                        setResourceState={setEvidenceStatisticModelCharacteristicState} />}
                {evidenceStatisticModelCharacteristicDotValueDatatypeState === 'Range' &&
                    <RangeEntry elementName='valueRange' fieldLabel='Value as Range'
                        startCollapsed
                        startingValue={evidenceStatisticModelCharacteristicState.valueRange}
                        setResourceState={setEvidenceStatisticModelCharacteristicState} />}
                {(isEndpointAnalysisPlanProfile && evidenceStatisticModelCharacteristicState.intended !== true) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the EndpointAnalysisPlan Profile. The statistic.modelCharacteristic.intended element is expected to have a value of 'true'.</p>}
                <BooleanEntry elementName='intended' fieldLabel='Intended' storeFalse={true}
                    startingValue={evidenceStatisticModelCharacteristicState.intended ?? null}
                    setResourceState={setEvidenceStatisticModelCharacteristicState} />
                {evidenceStatisticModelCharacteristicState.intended &&
                    <ExtensionStatisticModelIncludeIfEntry elementName='extension' fieldLabel='Include If'
                        startingValue={evidenceStatisticModelCharacteristicState.extension}
                        setResourceState={setEvidenceStatisticModelCharacteristicState} />}
                <BooleanEntry elementName='applied' fieldLabel='Applied' storeFalse={true}
                    startingValue={evidenceStatisticModelCharacteristicState.applied ?? null}
                    setResourceState={setEvidenceStatisticModelCharacteristicState} />
                <ArrayEntry datatype='EvidenceStatisticModelCharacteristicVariable' elementName='variable'
                    fieldLabel='Variable'
                    dataEntryStyle={evidenceStatisticModelCharacteristicState.intended && "includeIf"}
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticModelCharacteristicState.variable}
                    setResourceState={setEvidenceStatisticModelCharacteristicState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attribute'
                    fieldLabel='Attribute' startCollapsed
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticModelCharacteristicState.attributeEstimate}
                    setResourceState={setEvidenceStatisticModelCharacteristicState} />
            </div>
        </>
    }
};

const evidenceStatisticModelCharacteristicVariableDotVariableDefinitionResourceTypes = ['Group', 'EvidenceVariable'];
const EvidenceStatisticModelCharacteristicVariableEntry = ({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle }) => {

    const [evidenceStatisticModelCharacteristicVariableState, setEvidenceStatisticModelCharacteristicVariableState] = useState({});

    useEffect(() => {
        let startingVariable = {
            variableDefinition: "", handling: "", valueCategory: [], valueQuantity: [], valueRange: []
        }
        if (startingValue) {
            if (startingValue.extension) { startingVariable.extension = startingValue.extension; }
            if (startingValue.variableDefinition) { startingVariable.variableDefinition = startingValue.variableDefinition; }
            if (startingValue.handling) {
                startingVariable.handling = convertEvidenceVariableHandlingToCodeableConcept(startingValue.handling);
            }
            if (startingValue.valueCategory) { startingVariable.valueCategory = startingValue.valueCategory; }
            if (startingValue.valueQuantity) { startingVariable.valueQuantity = startingValue.valueQuantity; }
            if (startingValue.valueRange) { startingVariable.valueRange = startingValue.valueRange; }
        }
        setEvidenceStatisticModelCharacteristicVariableState(JSON.parse(JSON.stringify(startingVariable)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceStatisticModelCharacteristicVariableState).length > 0) {
            let newEvidenceStatisticModelCharacteristicVariable = {};
            if (evidenceStatisticModelCharacteristicVariableState.extension?.length > 0) { newEvidenceStatisticModelCharacteristicVariable.extension = evidenceStatisticModelCharacteristicVariableState.extension; }
            if (evidenceStatisticModelCharacteristicVariableState.variableDefinition && Object.keys(evidenceStatisticModelCharacteristicVariableState.variableDefinition).length > 0) {
                newEvidenceStatisticModelCharacteristicVariable.variableDefinition = evidenceStatisticModelCharacteristicVariableState.variableDefinition;
            }
            if (evidenceStatisticModelCharacteristicVariableState.handling &&
                Object.keys(evidenceStatisticModelCharacteristicVariableState.handling).length > 0
            ) {
                newEvidenceStatisticModelCharacteristicVariable.handling = evidenceStatisticModelCharacteristicVariableState.handling;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicVariableState.valueCategory) && evidenceStatisticModelCharacteristicVariableState.valueCategory.length > 0) {
                newEvidenceStatisticModelCharacteristicVariable.valueCategory = evidenceStatisticModelCharacteristicVariableState.valueCategory;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicVariableState.valueQuantity) && evidenceStatisticModelCharacteristicVariableState.valueQuantity.length > 0) {
                newEvidenceStatisticModelCharacteristicVariable.valueQuantity = evidenceStatisticModelCharacteristicVariableState.valueQuantity;
            }
            if (Array.isArray(evidenceStatisticModelCharacteristicVariableState.valueRange) && evidenceStatisticModelCharacteristicVariableState.valueRange.length > 0) {
                newEvidenceStatisticModelCharacteristicVariable.valueRange = evidenceStatisticModelCharacteristicVariableState.valueRange;
            }
            if (Object.keys(newEvidenceStatisticModelCharacteristicVariable).length === 0) {
                newEvidenceStatisticModelCharacteristicVariable = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceStatisticModelCharacteristicVariable }; });
        }
    }), [evidenceStatisticModelCharacteristicVariableState]);

    if (Object.keys(evidenceStatisticModelCharacteristicVariableState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <ReferenceEntry elementName='variableDefinition' fieldLabel='Variable Definition'
                    startingValue={evidenceStatisticModelCharacteristicVariableState.variableDefinition}
                    referencedResourceTypes={evidenceStatisticModelCharacteristicVariableDotVariableDefinitionResourceTypes}
                    setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />
                <CodeableConceptEntry elementName='handling' fieldLabel='Handling'
                    startingValue={evidenceStatisticModelCharacteristicVariableState.handling}
                    codeableConceptLevelValueSet={evidenceVariableDotHandlingValueSet}
                    setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />
                <ArrayEntry datatype='CodeableConcept' elementName='valueCategory'
                    fieldLabel='Value Option (as Category)'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticModelCharacteristicVariableState.valueCategory}
                    setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />
                <ArrayEntry datatype='Quantity' elementName='valueQuantity'
                    fieldLabel='Value Option (as Quantity)'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticModelCharacteristicVariableState.valueQuantity}
                    setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />
                <ArrayEntry datatype='Range' elementName='valueRange'
                    fieldLabel='Value Option (as Range)'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                    startingValue={evidenceStatisticModelCharacteristicVariableState.valueRange}
                    setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />
                {dataEntryStyle === "includeIf" &&
                    <ExtensionStatisticModelIncludeIfEntry elementName='extension' fieldLabel='Include If'
                        startingValue={evidenceStatisticModelCharacteristicVariableState.extension}
                        setResourceState={setEvidenceStatisticModelCharacteristicVariableState} />}
            </div>
        </>
    }
};

const StatisticCategoryEntry = ({ evidenceStatisticState, setEvidenceStatisticState }) => {
    return <CodeableConceptEntry elementName='category' fieldLabel='Category'
        startingValue={evidenceStatisticState.category} startCollapsed
        setResourceState={setEvidenceStatisticState} />
};

const StatisticDescriptionEntry = ({ evidenceStatisticState, setEvidenceStatisticState }) => {
    return <MarkdownEntry elementName='description' fieldLabel='Description'
        startCollapsed={!!evidenceStatisticState.description}
        startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
};

const StatisticNoteEntry = ({ evidenceStatisticState, setEvidenceStatisticState }) => {
    return <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
        startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
};

const StatisticQuantityEntry = ({ evidenceStatisticState, setEvidenceStatisticState }) => {
    return <QuantityEntry elementName='quantity' fieldLabel='Quantity'
        startingValue={evidenceStatisticState.quantity} startCollapsed={!!evidenceStatisticState.quantity}
        setResourceState={setEvidenceStatisticState} />
};

const StatisticTypeEntry = ({ codeableConceptLevelValueSet, evidenceStatisticState, setEvidenceStatisticState,
    isNetEffectContributionProfile, isNetEffectEstimateProfile
}) => {

    let WarningMessage;
    let netEffectRelatedProfile;
    if (isNetEffectContributionProfile) {
        netEffectRelatedProfile = "NetEffectContribution";
    }
    if (isNetEffectEstimateProfile) {
        netEffectRelatedProfile = "NetEffectEstimate";
    }
    if (netEffectRelatedProfile &&
        !(evidenceStatisticState.statisticType?.coding?.[0] &&
            evidenceStatisticState.statisticType.coding[0].system === "https://fevir.net/sevco" &&
            evidenceStatisticState.statisticType.coding[0].code === "STATO:0000424" &&
            evidenceStatisticState.statisticType.coding[0].display === "risk difference")) {
        WarningMessage = <p><b>WARNING: </b>This Evidence Resource follows the {netEffectRelatedProfile} Profile. The statistic.statisticType is expected to have a value of https://fevir.net/sevco#STATO:0000424 'risk difference'.</p>
    }
    if (netEffectRelatedProfile &&
        (evidenceStatisticState.statisticType?.coding?.[0] &&
            evidenceStatisticState.statisticType.coding[0].system === "https://fevir.net/sevco" &&
            evidenceStatisticState.statisticType.coding[0].code === "STATO:0000424" &&
            evidenceStatisticState.statisticType.coding[0].display === "risk difference") &&
        !(evidenceStatisticState.attributeEstimate?.[0]?.type?.coding?.[0] &&
            evidenceStatisticState.attributeEstimate[0].type.coding[0].system === "https://fevir.net/sevco" &&
            evidenceStatisticState.attributeEstimate[0].type.coding[0].code === "STATO:0000196" &&
            evidenceStatisticState.attributeEstimate[0].type.coding[0].display === "confidence interval")
    ) {
        WarningMessage = <p><b>WARNING: </b>This Evidence Resource follows the {netEffectRelatedProfile} Profile. The statistic.attributeEstimate.type is expected to have a value of https://fevir.net/sevco#STATO:0000196 'confidence interval'.</p>
    }
    return <>
        {WarningMessage && WarningMessage}
        <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
            startingValue={evidenceStatisticState.statisticType} startCollapsed={!!evidenceStatisticState.statisticType}
            valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={codeableConceptLevelValueSet}
            setResourceState={setEvidenceStatisticState} />
    </>
};

const EvidenceStatisticEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed, dataEntryStyle, outcomeHandling, outcomeCategories, populationQuantity,
    isStatisticModelProfile, isEndpointAnalysisPlanProfile, isParticipantFlowEvidenceProfile,
    isNetEffectContributionProfile, isNetEffectEstimateProfile }) => {

    const [evidenceStatisticState, setEvidenceStatisticState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);
    const [openAdvancedState, setOpenAdvancedState] = useState(false);

    useEffect(() => {
        let startingStatistic = {
            description: "", note: [], statisticType: "", category: "", quantity: "", numberOfEvents: "",
            numberAffected: "", sampleSize: "", attributeEstimate: [], modelCharacteristic: []
        }
        if (startingValue) {
            if (startingValue.extension) { startingStatistic.extension = startingValue.extension; }
            if (startingValue.description) { startingStatistic.description = startingValue.description; }
            if (startingValue.note) { startingStatistic.note = startingValue.note; }
            if (startingValue.statisticType) { startingStatistic.statisticType = startingValue.statisticType; }
            if (startingValue.category) { startingStatistic.category = startingValue.category; }
            if (startingValue.quantity) { startingStatistic.quantity = startingValue.quantity; }
            if (startingValue.numberOfEvents || startingValue.numberOfEvents === 0) { startingStatistic.numberOfEvents = startingValue.numberOfEvents; }
            if (startingValue.numberAffected || startingValue.numberAffected === 0) { startingStatistic.numberAffected = startingValue.numberAffected; }
            if (startingValue.sampleSize) {
                startingStatistic.sampleSize = startingValue.sampleSize;
            } else if (!isNaN(populationQuantity)) {
                startingStatistic.sampleSize = populationQuantity;
            }
            if (startingValue.attributeEstimate) { startingStatistic.attributeEstimate = startingValue.attributeEstimate; }
            if (startingValue.modelCharacteristic) { startingStatistic.modelCharacteristic = startingValue.modelCharacteristic; }
        }
        setEvidenceStatisticState(JSON.parse(JSON.stringify(startingStatistic)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceStatisticState).length > 0) {
            let newEvidenceStatistic = {};
            if (evidenceStatisticState.extension) { newEvidenceStatistic.extension = evidenceStatisticState.extension; }
            if (evidenceStatisticState.description) { newEvidenceStatistic.description = evidenceStatisticState.description; }
            if (Array.isArray(evidenceStatisticState.note) && evidenceStatisticState.note.length > 0) {
                newEvidenceStatistic.note = evidenceStatisticState.note;
            }
            if (evidenceStatisticState.statisticType && Object.keys(evidenceStatisticState.statisticType).length > 0) {
                newEvidenceStatistic.statisticType = evidenceStatisticState.statisticType;
            }
            if (evidenceStatisticState.category && Object.keys(evidenceStatisticState.category).length > 0) {
                newEvidenceStatistic.category = evidenceStatisticState.category;
            }
            if (evidenceStatisticState.quantity && Object.keys(evidenceStatisticState.quantity).length > 0) {
                newEvidenceStatistic.quantity = evidenceStatisticState.quantity;
            }
            if (evidenceStatisticState.numberOfEvents || evidenceStatisticState.numberOfEvents === 0) {
                newEvidenceStatistic.numberOfEvents = evidenceStatisticState.numberOfEvents;
            }
            if (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0) {
                newEvidenceStatistic.numberAffected = evidenceStatisticState.numberAffected;
            }
            if (evidenceStatisticState.sampleSize && Object.keys(evidenceStatisticState.sampleSize).length > 0) {
                newEvidenceStatistic.sampleSize = evidenceStatisticState.sampleSize;
            }
            if (Array.isArray(evidenceStatisticState.attributeEstimate) && evidenceStatisticState.attributeEstimate.length > 0) {
                newEvidenceStatistic.attributeEstimate = evidenceStatisticState.attributeEstimate;
            }
            if (Array.isArray(evidenceStatisticState.modelCharacteristic) && evidenceStatisticState.modelCharacteristic.length > 0) {
                newEvidenceStatistic.modelCharacteristic = evidenceStatisticState.modelCharacteristic;
            }
            if (Object.keys(newEvidenceStatistic).length === 0) {
                newEvidenceStatistic = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceStatistic }; });
        }
    }), [evidenceStatisticState]);

    let statisticTypeDisplay = "";
    if (startingValue?.statisticType) {
        if (startingValue.statisticType.coding?.length > 0) {
            if (startingValue.statisticType.coding[0].display) {
                statisticTypeDisplay = startingValue.statisticType.coding[0].display;
            } else if (startingValue.statisticType.coding[0].code) {
                statisticTypeDisplay = startingValue.statisticType.coding[0].code;
            }
        }
        if (startingValue.statisticType.text) {
            statisticTypeDisplay += "   " + startingValue.statisticType.text;
        }
    }
    let statisticValue = "";
    if (startingValue?.quantity) {
        let comparator = "";
        if (startingValue.quantity.comparator) {
            comparator = startingValue.quantity.comparator + " ";
        }
        let unit = "";
        if (startingValue.quantity.unit) {
            unit = " " + startingValue.quantity.unit;
        }
        let value = startingValue.quantity.value;
        if (value && !unit && statisticTypeDisplay.replace("   ", "").toLowerCase() === "percentage") {
            unit = "%";
        }
        statisticValue = comparator + value + unit;
    }
    let sampleSizeQuantified = "";
    if (startingValue?.sampleSize) {
        if (startingValue.sampleSize.numberOfStudies) {
            sampleSizeQuantified = startingValue.sampleSize.numberOfStudies + " studies";
        }
        if (startingValue.sampleSize.numberOfParticipants) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.numberOfParticipants + " participants";
        }
        if (startingValue.sampleSize.numberAnalyzed) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.numberAnalyzed + " analyzed";
        }
        if (startingValue.sampleSize.knownDataCount) {
            if (sampleSizeQuantified) {
                sampleSizeQuantified += ", ";
            }
            sampleSizeQuantified += startingValue.sampleSize.knownDataCount + " without missing data";
        }
    }

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.category && <span><b>Category:</b> {startingValue.category.text}</span>}
                {startingValue.description && <span>
                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                </span>}
                {Array.isArray(startingValue.note) && startingValue.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}
                <Table style={{ margin: "4px", width: "600px" }}><Table.Body>
                    <Table.Row><Table.Cell style={{ width: "280px", paddingTop: "6px", paddingBottom: "6px", paddingLeft: "12px" }}>
                        <b>{statisticTypeDisplay}</b>
                    </Table.Cell>
                        <Table.Cell style={{ paddingTop: "6px", paddingBottom: "6px", paddingLeft: "12px" }}>
                            <b>{statisticValue}</b>
                        </Table.Cell></Table.Row>
                </Table.Body></Table>
                {!isNaN(startingValue.numberOfEvents) && <span><b>Number of Events: </b>{startingValue.numberOfEvents}<br /></span>}
                {!isNaN(startingValue.numberAffected) && <span><b>Number Affected: </b>{startingValue.numberAffected}<br /></span>}
                {startingValue.sampleSize && <><b>Sample Size: </b>
                    <div style={{ marginLeft: "24px" }}>
                        {sampleSizeQuantified && <><b></b>{sampleSizeQuantified}<br /></>}
                        {startingValue.sampleSize.description && <span><b>Sample Size Description: </b><DisplayFromFHIRMarkdown markdown={startingValue.sampleSize.description} /><br /></span>}
                        {Array.isArray(startingValue.sampleSize.note) && startingValue.sampleSize.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}
                    </div>
                </>}
                {startingValue.attributeEstimate?.length > 0 &&
                    <Table style={{ margin: "4px" }}>
                        <Table.Header><Table.Row>
                            <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                            <Table.HeaderCell style={{ padding: "6px" }}>Value</Table.HeaderCell>
                            <Table.HeaderCell style={{ padding: "6px" }}>Notes</Table.HeaderCell>
                        </Table.Row></Table.Header>
                        <Table.Body>
                            {startingValue.attributeEstimate.map((attributeEstimate, aeIndex) => {
                                let calculatedPercentageAttribute = false;
                                let attribute = "";
                                if (attributeEstimate.level) {
                                    attribute = 100 * attributeEstimate.level + "% ";
                                }
                                if (attributeEstimate.type) {
                                    if (attributeEstimate.type.coding?.length > 0) {
                                        if (attributeEstimate.type.coding[0].display) {
                                            attribute += attributeEstimate.type.coding[0].display;
                                        } else if (attributeEstimate.type.coding[0].code) {
                                            attribute += attributeEstimate.type.coding[0].code;
                                        }
                                    }
                                    if (attributeEstimate.type.text) {
                                        if (attributeEstimate.type.text.toLowerCase() === "percentage") {
                                            calculatedPercentageAttribute = true;
                                        }
                                        attribute += " " + attributeEstimate.type.text;
                                    }
                                }
                                let attributeValue = "";
                                if (attributeEstimate.quantity) {
                                    let comparator = "";
                                    if (attributeEstimate.quantity.comparator) {
                                        comparator = attributeEstimate.quantity.comparator + " ";
                                    }
                                    let unit = "";
                                    if (attributeEstimate.quantity.unit) {
                                        unit = " " + attributeEstimate.quantity.unit;
                                    }
                                    let attributeEstimateValue = "";
                                    if (attributeEstimate.quantity.value !== undefined) {
                                        attributeEstimateValue = attributeEstimate.quantity.value
                                    }
                                    attributeValue = comparator + attributeEstimate.quantity.value + unit;
                                    if (calculatedPercentageAttribute && attributeEstimate.quantity.value && (comparator === "" || comparator === " ") && attributeEstimate.quantity.unit === "%") {
                                        try {
                                            //The plus symbol belongs here, +parseFloat(4).toFixed(2) === 4 as an int vs parseFloat(4).toFixed(2) === "4.00" as a string
                                            attributeEstimateValue = +parseFloat(attributeEstimate.quantity.value).toFixed(2);
                                            if (attributeEstimateValue.toString() !== "NaN") {
                                                attributeValue = attributeEstimateValue + unit;
                                            }
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                }
                                if (attributeValue === "" && attributeEstimate.range) {
                                    let lowValue = "No Lower Bound";
                                    let highValue = "No Upper Bound";
                                    if (attributeEstimate.range.low?.value !== undefined) {
                                        lowValue = attributeEstimate.range.low.value;
                                        if (attributeEstimate.range.low.unit) {
                                            lowValue += " " + attributeEstimate.range.low.unit;
                                        }
                                    }
                                    if (attributeEstimate.range.high?.value !== undefined) {
                                        highValue = attributeEstimate.range.high.value;
                                        if (attributeEstimate.range.high.unit) {
                                            highValue += " " + attributeEstimate.range.high.unit;
                                        }
                                    }
                                    attributeValue = lowValue + " to " + highValue;
                                }
                                return <Table.Row key={aeIndex}>
                                    <Table.Cell>{attribute}</Table.Cell>
                                    <Table.Cell>{attributeValue}</Table.Cell>
                                    <Table.Cell>
                                        {attributeEstimate.description && <><b>Description: </b><DisplayFromFHIRMarkdown markdown={attributeEstimate.description} /><br /></>}
                                        {attributeEstimate.note && <>{attributeEstimate.note.map((note, noteIndex) => { return <span key={noteIndex}><b>Note:</b> {note.text}<br /></span> })}</>}
                                    </Table.Cell>
                                </Table.Row>
                            }
                            )}
                        </Table.Body>
                    </Table>}
                {(Array.isArray(startingValue.modelCharacteristic) &&
                    startingValue.modelCharacteristic.length > 0) &&
                    startingValue.modelCharacteristic.map((item, itemIndex) => {
                        return <div key={itemIndex}>
                            <p><b>Model Characteristic {itemIndex + 1} of {startingValue.modelCharacteristic.length}</b></p>
                            <div style={{ marginLeft: "24px" }}>
                                <ModelCharacteristicDisplay modelCharactersticInstance={item} />
                            </div>
                        </div>
                    })}
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (dataEntryStyle === "continuous") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <StatisticDescriptionEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <StatisticTypeEntry codeableConceptLevelValueSet={continuousStatisticsConceptSet}
                    evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile}
                />
                <StatisticQuantityEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState); }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <StatisticNoteEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <StatisticCategoryEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                    <br /><br />
                    {(isParticipantFlowEvidenceProfile &&
                        (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0)) &&
                        <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.numberAffected is not expected to have content.</p>}
                    <span><b>Number Affected:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                            startingValue={evidenceStatisticState.numberAffected}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "dichotomous") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <StatisticDescriptionEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                {(isParticipantFlowEvidenceProfile &&
                    (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0)) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.numberAffected is not expected to have content.</p>}
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <StatisticTypeEntry codeableConceptLevelValueSet={dichotomousStatisticsConceptSet}
                    evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile} />
                <StatisticQuantityEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState); }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                    <StatisticNoteEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <StatisticCategoryEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "categorical") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed={!!evidenceStatisticState.category}
                    setResourceState={setEvidenceStatisticState} />
                <StatisticDescriptionEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                {(isParticipantFlowEvidenceProfile &&
                    (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0)) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.numberAffected is not expected to have content.</p>}
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <StatisticTypeEntry codeableConceptLevelValueSet={categoricalStatisticsConceptSet}
                    evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile} />
                <StatisticQuantityEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState); }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                    <StatisticNoteEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                </div>}
            </div>
        </>
    } else if (dataEntryStyle === "comparative") {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                {outcomeCategories?.length > 0 && <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed={!!evidenceStatisticState.category}
                    setResourceState={setEvidenceStatisticState} />}
                <StatisticDescriptionEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <br /><br />
                {(isParticipantFlowEvidenceProfile &&
                    (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0)) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.numberAffected is not expected to have content.</p>}
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <StatisticTypeEntry codeableConceptLevelValueSet={comparativeStatisticsConceptSet}
                    evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile} />
                <StatisticQuantityEntry evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState} />
                {(outcomeHandling === "continuous") && <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={!!evidenceStatisticState.attributeEstimate}
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />}
                <br /><br />
                <span className={"unselectable"} style={{ cursor: "pointer" }}
                    onClick={() => { setOpenAdvancedState(!openAdvancedState); }}>
                    {openAdvancedState ? <>Collapse Advanced Data Entry ▼</> : <>Expand Advanced Data Entry ►</>}
                </span>
                {openAdvancedState && <div>
                    {(outcomeHandling !== "continuous") && <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                        startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />}
                    <StatisticNoteEntry evidenceStatisticState={evidenceStatisticState}
                        setEvidenceStatisticState={setEvidenceStatisticState} />
                    <br /><br />
                    <span><b>Number of Events:</b>
                        &nbsp;&nbsp;
                        <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                            startingValue={evidenceStatisticState.numberOfEvents}
                            setResourceState={setEvidenceStatisticState} />
                    </span>
                    {!(outcomeCategories?.length > 0) &&
                        <StatisticCategoryEntry evidenceStatisticState={evidenceStatisticState}
                            setEvidenceStatisticState={setEvidenceStatisticState} />}
                </div>}
            </div>
        </>
    } else {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description'
                    startCollapsed
                    startingValue={evidenceStatisticState.description} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.note} setResourceState={setEvidenceStatisticState} />
                <StatisticTypeEntry codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                    evidenceStatisticState={evidenceStatisticState}
                    setEvidenceStatisticState={setEvidenceStatisticState}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile} />
                <CodeableConceptEntry elementName='category' fieldLabel='Category'
                    startingValue={evidenceStatisticState.category} startCollapsed
                    setResourceState={setEvidenceStatisticState} />
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={evidenceStatisticState.quantity}
                    setResourceState={setEvidenceStatisticState} />
                <br /><br />
                <span><b>Number of Events:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberOfEvents' fieldLabel='Number of Events'
                        startingValue={evidenceStatisticState.numberOfEvents}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <br /><br />
                {(isParticipantFlowEvidenceProfile &&
                    (evidenceStatisticState.numberAffected || evidenceStatisticState.numberAffected === 0)) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.numberAffected is not expected to have content.</p>}
                <span><b>Number Affected:</b>
                    &nbsp;&nbsp;
                    <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number Affected'
                        startingValue={evidenceStatisticState.numberAffected}
                        setResourceState={setEvidenceStatisticState} />
                </span>
                <EvidenceStatisticSampleSizeEntry elementName='sampleSize' fieldLabel='Sample Size'
                    startingValue={evidenceStatisticState.sampleSize} setResourceState={setEvidenceStatisticState} />
                <ArrayEntry datatype='EvidenceStatisticAttributeEstimate' elementName='attributeEstimate' fieldLabel='Attribute Estimate'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.attributeEstimate} setResourceState={setEvidenceStatisticState} />
                {(isParticipantFlowEvidenceProfile && evidenceStatisticState.modelCharacteristic?.length) &&
                    <p><b>WARNING: </b>This Evidence Resource follows the ParticipantFlowEvidence Profile. The statistic.modelCharacteristic is not expected to have content.</p>}
                <ArrayEntry datatype="EvidenceStatisticModelCharacteristic"
                    elementName='modelCharacteristic' fieldLabel='Model Characteristic'
                    deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceStatisticState.modelCharacteristic}
                    setResourceState={setEvidenceStatisticState}
                    isStatisticModelProfile={isStatisticModelProfile}
                    isEndpointAnalysisPlanProfile={isEndpointAnalysisPlanProfile}
                    isParticipantFlowEvidenceProfile={isParticipantFlowEvidenceProfile}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile} />
            </div>
        </>
    }
};

const certaintyTypeValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/certainty-type",
            "code": "Overall",
            "display": "Overall certainty"
        }]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "RiskOfBias",
                "display": "Risk of bias"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Inconsistency",
                "display": "Inconsistency"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Indirectness",
                "display": "Indirectness"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "Imprecision",
                "display": "Imprecision"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "PublicationBias",
                "display": "Publication bias"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "DoseResponseGradient",
                "display": "Dose response gradient"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "PlausibleConfounding",
                "display": "Plausible confounding"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-type",
                "code": "LargeEffect",
                "display": "Large effect"
            }
        ]
    }
];
const certaintyRatingValueSet = [
    {
        "coding": [{
            "system": "http://hl7.org/fhir/certainty-rating",
            "code": "high",
            "display": "High quality"
        }]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "moderate",
                "display": "Moderate quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "low",
                "display": "Low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "very-low",
                "display": "Very low quality"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "no-concern",
                "display": "no serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "serious-concern",
                "display": "serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "very-serious-concern",
                "display": "very serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "extremely-serious-concern",
                "display": "extremely serious concern"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "present",
                "display": "present"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "absent",
                "display": "absent"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "no-change",
                "display": "no change to rating"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode1",
                "display": "reduce rating: -1"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode2",
                "display": "reduce rating: -2"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "downcode3",
                "display": "reduce rating: -3"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "upcode1",
                "display": "increase rating: +1"
            }
        ]
    },
    {
        "coding": [
            {
                "system": "http://hl7.org/fhir/certainty-rating",
                "code": "upcode2",
                "display": "increase rating: +2"
            }
        ]
    }
];

const EvidenceCertaintyEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceCertaintyState, setEvidenceCertaintyEstimateState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingCertainty = {
            "description": "", "note": [], "type": "", "rating": "", "rater": [], "subcomponent": ""
        };
        if (startingValue) {
            if (startingValue.extension) { startingCertainty.extension = startingValue.extension; }
            if (startingValue.description) { startingCertainty.description = startingValue.description; }
            if (startingValue.note) { startingCertainty.note = startingValue.note; }
            if (startingValue.type) { startingCertainty.type = startingValue.type; }
            if (startingValue.rating) { startingCertainty.rating = startingValue.rating; }
            if (startingValue.rater) { startingCertainty.rater = startingValue.rater; }
            if (startingValue.subcomponent) { startingCertainty.subcomponent = startingValue.subcomponent; }
        }
        setEvidenceCertaintyEstimateState(JSON.parse(JSON.stringify(startingCertainty)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceCertaintyState).length > 0) {
            let newCertainty = {};
            if (evidenceCertaintyState.extension) { newCertainty.extension = evidenceCertaintyState.extension; }
            if (evidenceCertaintyState.description) { newCertainty.description = evidenceCertaintyState.description; }
            if (Array.isArray(evidenceCertaintyState.note) && evidenceCertaintyState.note.length > 0) {
                newCertainty.note = evidenceCertaintyState.note;
            }
            if (evidenceCertaintyState.type && Object.keys(evidenceCertaintyState.type).length > 0) {
                newCertainty.type = evidenceCertaintyState.type;
            }
            if (evidenceCertaintyState.rating && Object.keys(evidenceCertaintyState.rating).length > 0) {
                newCertainty.rating = evidenceCertaintyState.rating;
            }
            if (Array.isArray(evidenceCertaintyState.rater) && evidenceCertaintyState.rater.length > 0) {
                newCertainty.rater = evidenceCertaintyState.rater;
            }
            if (Array.isArray(evidenceCertaintyState.subcomponent) && evidenceCertaintyState.subcomponent.length > 0) {
                newCertainty.subcomponent = evidenceCertaintyState.subcomponent;
            }
            if (Object.keys(newCertainty).length === 0) {
                newCertainty = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newCertainty }; });
        }
    }), [evidenceCertaintyState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                <Table style={{ margin: "4px" }}>
                    <Table.Header><Table.Row>
                        <Table.HeaderCell className={"leftAlignedCell"} style={{ padding: "6px", width: "360px" }}>Attribute</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Rating</Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: "6px" }}>Comments</Table.HeaderCell>
                    </Table.Row></Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                {startingValue.type && <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.type} />}
                                {startingValue.rater && <p>Rated by {startingValue.rater.join("; ")}</p>}
                            </Table.Cell>
                            <Table.Cell>
                                {startingValue.rating && <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.rating} />}
                            </Table.Cell>
                            <Table.Cell>
                                {startingValue.description && <>
                                    <DisplayFromFHIRMarkdown markdown={startingValue.description} /><br />
                                </>}
                                {startingValue.note && <>
                                    {startingValue.note.map((note, noteIndex) => {
                                        return <span key={noteIndex}>
                                            <b>Note:</b> {note.text}<br />
                                        </span>
                                    })}
                                </>}
                            </Table.Cell>
                        </Table.Row>
                        {(Array.isArray(startingValue.subcomponent) && startingValue.subcomponent.length > 0) &&
                            startingValue.subcomponent.map((part, partIndex) => {
                                return <Table.Row key={partIndex}>
                                    <Table.Cell>
                                        {part.type && <DisplayFromFHIRCodeableConcept codeableConcept={part.type} />}
                                        {part.rater && <p>Rated by {part.rater.join("; ")}</p>}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {part.rating && <DisplayFromFHIRCodeableConcept codeableConcept={part.rating} />}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {part.description && <>
                                            <DisplayFromFHIRMarkdown markdown={part.description} /><br />
                                        </>}
                                        {part.note && <>
                                            {part.note.map((note, noteIndex) => {
                                                return <span key={noteIndex}>
                                                    <b>Note:</b> {note.text}<br />
                                                </span>
                                            })}
                                        </>}
                                    </Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                </Table>
                <br />
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(evidenceCertaintyState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <MarkdownEntry elementName='description' fieldLabel='Description/Summary' startCollapsed
                    startingValue={evidenceCertaintyState.description}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.note} setResourceState={setEvidenceCertaintyEstimateState} />
                <CodeableConceptEntry elementName='type' fieldLabel='Attribute Type'
                    startingValue={evidenceCertaintyState.type}
                    codeableConceptLevelValueSet={certaintyTypeValueSet}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <CodeableConceptEntry elementName='rating' fieldLabel='Rating Value'
                    startingValue={evidenceCertaintyState.rating}
                    codeableConceptLevelValueSet={certaintyRatingValueSet}
                    setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='string' elementName='rater' fieldLabel='Rater (Name)'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.rater} setResourceState={setEvidenceCertaintyEstimateState} />
                <ArrayEntry datatype='EvidenceCertainty' elementName='subcomponent' fieldLabel='Subcomponent'
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed
                    startingValue={evidenceCertaintyState.subcomponent} setResourceState={setEvidenceCertaintyEstimateState} />
            </div>
        </>
    }
};

const pValueComparatorOptions = [{ "key": "0", "value": "=", "text": "=" }, { "key": "1", "value": "<", "text": "<" }, { "key": "2", "value": ">", "text": ">" }];
const InitialStatisticEntry = ({ resourceState, setResourceState, statisticType, statisticUnit, setStatisticsAvailable, numberAnalyzed }) => {

    const isInitialMount = useRef(true);
    let initialStatistic = {};
    if (numberAnalyzed || numberAnalyzed === 0) { //If numberAnalyzed has a value even "0" or 0, then we setInitialStatisticState
        initialStatistic["numberAnalyzed"] = numberAnalyzed; //?? undefined
    }
    if (statisticType) {
        initialStatistic["statisticType"] = statisticType;
    }
    if (statisticUnit) {
        initialStatistic["quantity"] = { "unit": statisticUnit };
    }
    const [initialStatisticState, setInitialStatisticState] = useState(initialStatistic);
    const [initialAttributeEstimateState, setInitialAttributeEstimateState] = useState({
        "lowValue": "", "highValue": "",
        "comparator": "", "pValue": "", "standardDeviation": ""
    });

    useEffect(() => {
        if (!isInitialMount.current && Object.keys(initialAttributeEstimateState).length) {
            let attributeEstimate = [];
            if ((initialAttributeEstimateState.lowValue || initialAttributeEstimateState.lowValue === 0) &&
                (initialAttributeEstimateState.highValue || initialAttributeEstimateState.highValue === 0)) {
                let lowEnd = { value: initialAttributeEstimateState.lowValue };
                let highEnd = { value: initialAttributeEstimateState.highValue };
                if (initialStatisticState.quantity?.unit) {
                    lowEnd.unit = initialStatisticState.quantity.unit;
                    highEnd.unit = initialStatisticState.quantity.unit;
                }
                if (initialStatisticState.quantity?.system) {
                    lowEnd.system = initialStatisticState.quantity.system;
                    highEnd.system = initialStatisticState.quantity.system;
                }
                if (initialStatisticState.quantity?.code) {
                    lowEnd.code = initialStatisticState.quantity.code;
                    highEnd.code = initialStatisticState.quantity.code;
                }
                let instance = {
                    type: {
                        coding: [{
                            system: "https://fevir.net/sevco",
                            code: "STATO:0000196",
                            display: "confidence interval"
                        }]
                    },
                    level: 0.95,
                    range: { low: lowEnd, high: highEnd }
                };
                attributeEstimate.push(instance);
            }
            if (initialAttributeEstimateState.pValue) {
                let instance = {
                    type: {
                        coding: [{
                            system: "https://fevir.net/sevco",
                            code: "STATO:0000700",
                            display: "p-value"
                        }]
                    },
                    quantity: {
                        comparator: initialAttributeEstimateState.comparator,
                        value: initialAttributeEstimateState.pValue
                    }
                };
                if (initialAttributeEstimateState.comparator !== ">" && initialAttributeEstimateState.comparator !== "<") {
                    delete instance.quantity.comparator;
                }
                attributeEstimate.push(instance);
            }
            if (initialAttributeEstimateState.standardDeviation) {
                let instance = {
                    type: {
                        coding: [{
                            system: "https://fevir.net/sevco",
                            code: "STATO:0000684",
                            display: "standard deviation for sample"
                        }]
                    },
                    quantity: {
                        value: initialAttributeEstimateState.standardDeviation
                    }
                };
                if (initialStatisticState.quantity?.unit) {
                    instance.quantity.unit = initialStatisticState.quantity.unit;
                }
                if (initialStatisticState.quantity?.system) {
                    instance.quantity.system = initialStatisticState.quantity.system;
                }
                if (initialStatisticState.quantity?.code) {
                    instance.quantity.code = initialStatisticState.quantity.code;
                }
                attributeEstimate.push(instance);
            }
            if (attributeEstimate.length > 0) {
                setInitialStatisticState(prevState => {
                    return { ...prevState, attributeEstimate: attributeEstimate };
                });
            }
        }
    }, [initialAttributeEstimateState]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else if (Object.keys(initialStatisticState).length) {
            updateFirstStatistic();
        }
    }, [initialStatisticState]);

    const addProportion = () => {
        let denominator = initialStatisticState.numberAnalyzed;
        if (!denominator) {
            denominator = initialStatisticState.numberOfParticipants;
            if (initialStatisticState.missingDataCount) {
                denominator -= initialStatisticState.missingDataCount;
            }
        }
        let statistic = {
            numberAffected: initialStatisticState.numberAffected,
            statisticType: {
                coding: [{
                    system: "https://fevir.net/sevco",
                    code: "STATO:0000607",
                    display: "proportion"
                }]
            },
            quantity: { value: initialStatisticState.numberAffected / denominator }
        };
        if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
            initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
            let sampleSize = {};
            if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0) {
                sampleSize.numberOfParticipants = initialStatisticState.numberOfParticipants;
            };
            if (initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                sampleSize.numberAnalyzed = initialStatisticState.numberAnalyzed;
            };
            if (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) {
                let denominator = initialStatisticState.numberAnalyzed || initialStatisticState.numberOfParticipants;
                let knownDataCount = denominator - initialStatisticState.missingDataCount;
                sampleSize.knownDataCount = knownDataCount;
            }
            statistic.sampleSize = sampleSize;
        }
        if (initialStatisticState.attributeEstimate) {
            statistic.attributeEstimate = initialStatisticState.attributeEstimate;
        }
        setResourceState(prevState => { return { ...prevState, "statistic": [statistic] }; });
        setStatisticsAvailable(1);
    };

    const addPercentage = () => {
        let denominator = initialStatisticState.numberAnalyzed;
        if (!denominator) {
            denominator = initialStatisticState.numberOfParticipants;
            if (initialStatisticState.missingDataCount) {
                denominator -= initialStatisticState.missingDataCount;
            }
        }
        let statistic = {
            numberAffected: initialStatisticState.numberAffected,
            statisticType: {
                coding: [{
                    system: "https://fevir.net/sevco",
                    code: "STATO:0000639",
                    display: "percentage"
                }]
            },
            quantity: {
                value: 100 * initialStatisticState.numberAffected / denominator,
                unit: "%", system: "http://unitsofmeasure.org", code: "%"
            }
        };
        if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
            initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
            let sampleSize = {};
            if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0) {
                sampleSize.numberOfParticipants = initialStatisticState.numberOfParticipants;
            };
            if (initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                sampleSize.numberAnalyzed = initialStatisticState.numberAnalyzed;
            };
            if (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) {
                let denominator = initialStatisticState.numberAnalyzed || initialStatisticState.numberOfParticipants;
                let knownDataCount = denominator - initialStatisticState.missingDataCount;
                sampleSize.knownDataCount = knownDataCount;
            }
            statistic.sampleSize = sampleSize;
        }
        if (initialStatisticState.attributeEstimate) {
            statistic.attributeEstimate = initialStatisticState.attributeEstimate;
        }
        setResourceState(prevState => { return { ...prevState, "statistic": [statistic] }; });
        setStatisticsAvailable(1);
    };

    const addCount = () => {
        let statistic = {
            statisticType: {
                coding: [{
                    system: "https://fevir.net/sevco",
                    code: "STATO:0000047",
                    display: "count"
                }]
            },
            quantity: {
                value: initialStatisticState.numberAffected,
                system: "http://unitsofmeasure.org", code: "1"
            }
        };
        if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
            initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
            let sampleSize = {};
            if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0) {
                sampleSize.numberOfParticipants = initialStatisticState.numberOfParticipants;
            };
            if (initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                sampleSize.numberAnalyzed = initialStatisticState.numberAnalyzed;
            };
            if (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) {
                let denominator = initialStatisticState.numberAnalyzed || initialStatisticState.numberOfParticipants;
                let knownDataCount = denominator - initialStatisticState.missingDataCount;
                sampleSize.knownDataCount = knownDataCount;
            }
            statistic.sampleSize = sampleSize;
        }
        if (initialStatisticState.attributeEstimate) {
            statistic.attributeEstimate = initialStatisticState.attributeEstimate;
        }
        setResourceState(prevState => { return { ...prevState, "statistic": [statistic] }; });
        setStatisticsAvailable(1);
    };

    const updateFirstStatistic = () => {
        let statistic = {
            statisticType: initialStatisticState.statisticType,
            quantity: initialStatisticState.quantity
        };
        if (initialStatisticState.numberAffected || initialStatisticState.numberAffected === 0) {
            statistic.numberAffected = initialStatisticState.numberAffected;
        }
        if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0 ||
            initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
            let sampleSize = {};
            if (initialStatisticState.numberOfParticipants || initialStatisticState.numberOfParticipants === 0) {
                sampleSize.numberOfParticipants = initialStatisticState.numberOfParticipants;
            };
            if (initialStatisticState.numberAnalyzed || initialStatisticState.numberAnalyzed === 0) {
                sampleSize.numberAnalyzed = initialStatisticState.numberAnalyzed;
            };
            if (initialStatisticState.missingDataCount || initialStatisticState.missingDataCount === 0) {
                let denominator = initialStatisticState.numberAnalyzed || initialStatisticState.numberOfParticipants;
                let knownDataCount = denominator - initialStatisticState.missingDataCount;
                sampleSize.knownDataCount = knownDataCount;
            }
            statistic.sampleSize = sampleSize;
        }
        if (initialStatisticState.attributeEstimate) {
            statistic.attributeEstimate = initialStatisticState.attributeEstimate;
        }
        setResourceState(prevState => { return { ...prevState, "statistic": [statistic] }; });
    }

    return <>
        <span><b>Sample Size:</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberOfParticipants' fieldLabel='Number of Participants'
                startingValue={initialStatisticState.numberOfParticipants}
                setResourceState={setInitialStatisticState} />
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberAnalyzed' fieldLabel='Number Analyzed'
                startingValue={initialStatisticState.numberAnalyzed}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Missing Data Count:</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='missingDataCount' fieldLabel='Number missing data for this outcome'
                startingValue={initialStatisticState.missingDataCount}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Number having this outcome (for boolean outcomes):</b>
            &nbsp;&nbsp;
            <UnsignedIntEntry elementName='numberAffected' fieldLabel='Number affected'
                startingValue={initialStatisticState.numberAffected}
                setResourceState={setInitialStatisticState} />
        </span>
        {(initialStatisticState.numberAffected || initialStatisticState.numberAffected === 0) && <div>
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Add proportion as the statistic value."}
                onClick={() => {
                    addProportion();
                }}
                disabled={!initialStatisticState.numberOfParticipants && !initialStatisticState.numberAnalyzed} />
            <br />
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Add percentage as the statistic value."}
                onClick={() => {
                    addPercentage();
                }}
                disabled={!initialStatisticState.numberOfParticipants && !initialStatisticState.numberAnalyzed} />
            <br />
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }}
                content={"Use count as the statistic value."}
                onClick={() => {
                    addCount();
                }}
                disabled={!initialStatisticState.numberOfParticipants && initialStatisticState.numberOfParticipants !== 0 &&
                    !initialStatisticState.numberAnalyzed && initialStatisticState.numberAnalyzed !== 0} />
        </div>}
        <br /><br />
        <span><b>Statistic type:</b>
            &nbsp;&nbsp;
            <CodeableConceptEntry elementName='statisticType' fieldLabel='Statistic Type'
                startingValue={initialStatisticState.statisticType}
                valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>Statistic Value (Quantity):</b>
            &nbsp;&nbsp;
            <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                startingValue={initialStatisticState.quantity}
                setResourceState={setInitialStatisticState} />
        </span>
        <br /><br />
        <span><b>95% Confidence Interval:</b>
            &nbsp;&nbsp;
            <DecimalEntry elementName='lowValue' fieldLabel='Low Value'
                startingValue={initialAttributeEstimateState.lowValue}
                setResourceState={setInitialAttributeEstimateState} />
            &nbsp;&nbsp;
            <DecimalEntry elementName='highValue' fieldLabel='High Value'
                startingValue={initialAttributeEstimateState.highValue}
                setResourceState={setInitialAttributeEstimateState} />
        </span>
        <br /><br />
        <span><b>p value:</b>
            &nbsp;&nbsp;
            <Dropdown className="dropdownWithClearIconUpperRight" name="comparator" placeholder="Comparator"
                closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
                style={{ minWidth: "18%", width: "18%" }}
                options={pValueComparatorOptions}
                value={initialAttributeEstimateState.comparator || ""}
                onChange={(e, data) => {
                    setInitialAttributeEstimateState(prevState => { return { ...prevState, comparator: data.value }; });
                }}
            />
            &nbsp;&nbsp;
            <DecimalEntry elementName='pValue' fieldLabel='p Value'
                startingValue={initialAttributeEstimateState.pValue}
                setResourceState={setInitialAttributeEstimateState} />
        </span>
        <br /><br />
        <span>Standard deviation:
            &nbsp;&nbsp;
            <DecimalEntry elementName='standardDeviation' fieldLabel='Standard deviation'
                startingValue={initialAttributeEstimateState.standardDeviation}
                setResourceState={setInitialAttributeEstimateState} />
        </span>
        <br /><br />
        <Button className="formButton" style={{ color: "blue", marginBottom: "12px" }}
            content={"Full statistic editing"}
            onClick={() => {
                if (!resourceState || !resourceState.statistic || resourceState.statistic.length === 0 || Object.keys(resourceState.statistic).length === 0) {
                    setResourceState(prevState => { return { ...prevState, "statistic": [{}] }; });
                }
                setStatisticsAvailable(1);
            }} />
    </>
};
/*
const updateEvidenceMap = (dispatch, comparativeEvidenceMap, editResourceState, foi) => {
    let newMap = JSON.parse(JSON.stringify(comparativeEvidenceMap));
    if (!newMap.combinedDictionary) {
        newMap.combinedDictionary = {};
    }
    if (!newMap.evidenceDisplayDictionary) {
        newMap.evidenceDisplayDictionary = {};
    }
    newMap.combinedDictionary[foi] = editResourceState;
    newMap.evidenceDisplayDictionary[foi] = createEvidenceDisplay(editResourceState);
    dispatch(changeComparativeEvidenceMap(newMap));
};
*/

const EvidenceResourceEdit = ({ foi, statisticType, statisticUnit, numberAnalyzed,
    setReferencedEvidenceRevisedState, setTriggerReloadState, setReferencedResourceState }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
   // const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);

    let isStatisticModelProfile;
    let isEndpointAnalysisPlanProfile;
    let isComparativeEvidenceProfile;
    let isNonComparativeEvidenceProfile;
    let isSingleStudyEvidenceProfile;
    let isParticipantFlowEvidenceProfile;
    let isComparativeParticipantFlowEvidenceProfile;
    let isEvidenceSynthesisEvidenceProfile;
    let isNetEffectContributionProfile;
    let isNetEffectEstimateProfile;
    let isComparatorOnlyEvidenceProfile;
    let isInterventionOnlyEvidenceProfile;
    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/statistic-model") {
                isStatisticModelProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/endpoint-analysis-plan") {
                isEndpointAnalysisPlanProfile = true;
                isStatisticModelProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence") {
                isComparativeEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-baseline-measure-evidence") {
                isComparativeEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-participant-flow-evidence") {
                isComparativeEvidenceProfile = true;
                isComparativeParticipantFlowEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/non-comparative-evidence") {
                isNonComparativeEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-measure-evidence") {
                isNonComparativeEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-evidence") {
                isNonComparativeEvidenceProfile = true;
                isParticipantFlowEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/single-study-evidence") {
                isSingleStudyEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-synthesis-evidence") {
                isEvidenceSynthesisEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-contribution") {
                isComparativeEvidenceProfile = true;
                isNetEffectContributionProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/net-effect-estimate") {
                isNetEffectEstimateProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparator-only-evidence") {
                isNonComparativeEvidenceProfile = true;
                isComparatorOnlyEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/intervention-only-evidence") {
                isNonComparativeEvidenceProfile = true;
                isInterventionOnlyEvidenceProfile = true;
            }
        }
    }

    const [editResourceState, setEditResourceState] = useState({});
    const [statisticsAvailable, setStatisticsAvailable] = useState(editResourceState?.statistic?.length && (editResourceState.statistic.length > 1 || Object.keys(editResourceState.statistic[0]).length));
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState({});

    useEffect(() => {
        let resourceJsonCopy = JSON.parse(JSON.stringify(resourceJson));
        if (foi.toString() === resourceJsonCopy.id.toString()) {
            setEditResourceState(resourceJsonCopy);
            setStatisticsAvailable(resourceJsonCopy?.statistic?.length && (resourceJsonCopy.statistic.length > 1 || Object.keys(resourceJsonCopy.statistic[0]).length));
        } else {
            alert("caught in the act " + foi + " vs. " + resourceJsonCopy.id + " is " + (foi.toString() === resourceJsonCopy.id.toString()))
        }
    }, [foi]);

    useEffect(() => {
        if (editResourceState.title || editResourceState.statistic) {
            let generatedNarrative = generateNarrativeForEvidenceResource(editResourceState);
            setGeneratedNarrativeState(generatedNarrative);
        }
        if (setReferencedResourceState) {
            setReferencedResourceState(editResourceState);
        }
    }, [editResourceState]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            updateNarrativeElement(editResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
            if (setReferencedEvidenceRevisedState !== undefined) {
              //  updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        }
    }, [editResourceState.text]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.title)) {
                console.log("resourceUpdate for Evidence.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "title",
                    previousInitialValue,
                    editResourceState.title);
            }
            if (setReferencedEvidenceRevisedState !== undefined) {
            //    updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
            if (setTriggerReloadState) { setTriggerReloadState(true); }
        }
    }, [editResourceState.title]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.name !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.name)) {
                console.log("resourceUpdate for Evidence.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "name",
                    previousInitialValue,
                    editResourceState.name);
            }
            if (setReferencedEvidenceRevisedState !== undefined) {
            //    updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        }
    }, [editResourceState.name]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            updateElement(editResourceState, "description", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
            if (setReferencedEvidenceRevisedState !== undefined) {
          //      updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        }
    }, [editResourceState.description]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            updateElement(editResourceState, "assertion", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
            if (setReferencedEvidenceRevisedState !== undefined) {
           //     updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        }
    }, [editResourceState.assertion]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            updateElement(editResourceState, "statistic", "ArrayOfEvidenceStatistic", parentResourceDetail,
                resourceChanges, dispatch);
            if (setReferencedEvidenceRevisedState !== undefined) {
              //  updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        //    if (setReferencedEvidenceRevisedState !== undefined) {
       //         console.log("about to call updateEvidenceMap")
      //          updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
      //      }
            //if (setTriggerReloadState) { setTriggerReloadState(true); }
        }
    }, [editResourceState.statistic]);

    useEffect(() => {
        if (editResourceState && Object.keys(editResourceState).length > 0) {
            updateElement(editResourceState, "certainty", "ArrayOfEvidenceCertainty", parentResourceDetail,
                resourceChanges, dispatch);
            if (setReferencedEvidenceRevisedState !== undefined) {
          //      updateEvidenceMap(dispatch, comparativeEvidenceMap, editResourceState, foi);
                setReferencedEvidenceRevisedState({
                    "foi": foi,
                    "evidenceJson": editResourceState
                });
            }
        }
    }, [editResourceState.certainty]);

    return <div style={{ marginLeft: "24px" }}>
        {(editResourceState && Object.keys(editResourceState).length > 0) && <>
            <StringEntry elementName='title'
                fieldLabel={'Title (Human-friendly Label for the Evidence Resource)'}
                startingValue={editResourceState.title || ""}
                required={(resourceJson?.description || resourceJson?.statistic)}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Description'}
                startingValue={editResourceState.description || ""}
                setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='assertion' fieldLabel={'Assertion'}
                startingValue={editResourceState.assertion || ""}
                setResourceState={setEditResourceState} />
            {statisticsAvailable ?
                <ArrayEntry datatype='EvidenceStatistic' elementName='statistic'
                    fieldLabel='Statistic' startingValue={editResourceState.statistic}
                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                    isStatisticModelProfile={isStatisticModelProfile}
                    isEndpointAnalysisPlanProfile={isEndpointAnalysisPlanProfile}
                    isParticipantFlowEvidenceProfile={isParticipantFlowEvidenceProfile}
                    isNetEffectContributionProfile={isNetEffectContributionProfile}
                    isNetEffectEstimateProfile={isNetEffectEstimateProfile}
                    setResourceState={setEditResourceState} />
                :
                <InitialStatisticEntry resourceState={editResourceState} setResourceState={setEditResourceState}
                    statisticType={statisticType} statisticUnit={statisticUnit}
                    numberAnalyzed={numberAnalyzed} setStatisticsAvailable={setStatisticsAvailable} />
            }
            <p>Narrative Summary</p>
            <div style={{ marginLeft: "24px" }}>
                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                    generatedNarrative={generatedNarrativeState} startCollapsed
                    calledFrom="EditResourceEdit"
                    startingValue={editResourceState.text} setResourceState={setEditResourceState} />
            </div>
            <ArrayEntry datatype='EvidenceCertainty' elementName='certainty'
                fieldLabel='Certainty' startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                startingValue={editResourceState.certainty}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name' fieldLabel='Name (Machine Label for the Evidence Resource)'
                startingValue={editResourceState.name || ""} setResourceState={setEditResourceState} />
        </>}
    </div>
};

export default EvidenceResourceEdit;
export {
    EvidenceStatisticEntry, EvidenceCertaintyEntry, EvidenceStatisticSampleSizeEntry,
    EvidenceStatisticAttributeEstimateEntry, InitialStatisticEntry,
    EvidenceStatisticModelCharacteristicEntry, EvidenceStatisticModelCharacteristicVariableEntry
};